// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════
   InviteModal — Discord-quality invite acceptance UI
   ═══════════════════════════════════════════════════ */

.invite-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: overlayFadeIn 0.25s ease-out;
}

@keyframes overlayFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.invite-modal {
  background-color: var(--bg-primary, #1e293b);
  width: 440px;
  max-width: 92vw;
  border-radius: 12px;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.05),
    0 16px 40px rgba(0,0,0,0.45),
    0 0 80px -20px rgba(56, 189, 248, 0.15);
  overflow: hidden;
  position: relative;
  animation: modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.92) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ── Close button ── */
.invite-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0,0,0,0.3);
  border: none;
  color: rgba(255,255,255,0.7);
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s;
  backdrop-filter: blur(4px);
}

.invite-close-btn:hover {
  background: rgba(255,255,255,0.15);
  color: white;
  transform: rotate(90deg);
}

/* ── Banner ── */
.invite-banner {
  position: relative;
  height: 100px;
  background: linear-gradient(135deg, #0ea5e9 0%, #7c3aed 50%, #ec4899 100%);
  overflow: hidden;
}

.invite-banner-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to top, var(--bg-primary, #1e293b), transparent);
}

/* ── Animated particles ── */
.invite-banner-particles {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  animation: particleFloat 6s ease-in-out infinite;
}

.particle-0 { left: 10%; top: 30%; animation-delay: 0s; width: 3px; height: 3px; }
.particle-1 { left: 25%; top: 60%; animation-delay: 0.8s; width: 5px; height: 5px; }
.particle-2 { left: 40%; top: 20%; animation-delay: 1.6s; width: 3px; height: 3px; }
.particle-3 { left: 55%; top: 50%; animation-delay: 2.4s; width: 4px; height: 4px; }
.particle-4 { left: 70%; top: 35%; animation-delay: 3.2s; width: 6px; height: 6px; }
.particle-5 { left: 85%; top: 65%; animation-delay: 4s; width: 3px; height: 3px; }
.particle-6 { left: 15%; top: 75%; animation-delay: 0.5s; width: 4px; height: 4px; }
.particle-7 { left: 50%; top: 80%; animation-delay: 1.3s; width: 5px; height: 5px; }
.particle-8 { left: 90%; top: 25%; animation-delay: 2.1s; width: 3px; height: 3px; }
.particle-9 { left: 5%; top: 45%; animation-delay: 2.9s; width: 4px; height: 4px; }
.particle-10 { left: 60%; top: 15%; animation-delay: 3.7s; width: 5px; height: 5px; }
.particle-11 { left: 35%; top: 70%; animation-delay: 4.5s; width: 3px; height: 3px; }

@keyframes particleFloat {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) scale(1.5);
    opacity: 0.8;
  }
}

/* ── Server icon ── */
.invite-server-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-top: -36px;
  position: relative;
  z-index: 5;
}

.invite-server-icon {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: var(--bg-secondary, #334155);
  border: 5px solid var(--bg-primary, #1e293b);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.invite-server-icon-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invite-server-icon-letter {
  font-size: 28px;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #0ea5e9, #7c3aed);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invite-online-badge {
  position: absolute;
  bottom: 2px;
  right: calc(50% - 40px);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #22c55e;
  border: 3px solid var(--bg-primary, #1e293b);
  animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.4); }
  50% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
}

/* ── Content ── */
.invite-content {
  padding: 16px 28px 28px;
  text-align: center;
}

.invite-subtitle {
  color: var(--text-muted, #94a3b8);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin: 0 0 4px;
}

.invite-server-name {
  color: var(--text-normal, #f8fafc);
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.3;
}

.invite-server-desc {
  color: var(--text-muted, #94a3b8);
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 16px;
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Meta row ── */
.invite-meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
}

.invite-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-muted, #94a3b8);
  font-size: 13px;
}

.invite-meta-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.invite-meta-dot-online {
  background-color: #22c55e;
}

/* ── Actions ── */
.invite-actions {
  display: flex;
  gap: 12px;
}

.invite-btn {
  flex: 1;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.invite-btn-secondary {
  background: transparent;
  color: var(--text-normal, #f8fafc);
  border: 1px solid rgba(255,255,255,0.1);
}

.invite-btn-secondary:hover {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.2);
}

.invite-btn-primary {
  background: linear-gradient(135deg, #0ea5e9, #7c3aed);
  color: white;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
}

.invite-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(14, 165, 233, 0.4);
}

.invite-btn-primary:active {
  transform: translateY(0);
}

.invite-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* ── Success state ── */
.invite-success {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  background: rgba(34,197,94,0.1);
  border: 1px solid rgba(34,197,94,0.2);
  border-radius: 8px;
  color: #22c55e;
  font-weight: 500;
  font-size: 14px;
  animation: successPop 0.3s ease-out;
}

@keyframes successPop {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* ── Error state ── */
.invite-error-state {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--text-muted, #94a3b8);
}

.invite-error-state svg {
  color: #ef4444;
  margin-bottom: 4px;
}

.invite-error-state h3 {
  color: var(--text-normal, #f8fafc);
  font-size: 18px;
  margin: 0;
}

.invite-error-state p {
  font-size: 13px;
  margin: 0 0 12px;
}

/* ── Loading skeletons ── */
.invite-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 0;
}

.invite-skeleton {
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0.04) 25%,
    rgba(255,255,255,0.08) 50%,
    rgba(255,255,255,0.04) 75%
  );
  background-size: 200% 100%;
  border-radius: 6px;
  animation: skeletonShimmer 1.5s infinite;
}

.invite-skeleton-title {
  width: 180px;
  height: 24px;
}

.invite-skeleton-desc {
  width: 260px;
  height: 14px;
}

.invite-skeleton-meta {
  width: 200px;
  height: 14px;
}

@keyframes skeletonShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Animate spin utility ── */
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/InviteModal/InviteModal.css"],"names":[],"mappings":"AAAA;;wDAEwD;;AAExD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB;;;2CAGyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4EAA4E;AAC9E;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA,cAAc,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE,UAAU,EAAE,WAAW,EAAE;AACjF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE,UAAU,EAAE,WAAW,EAAE;AACjF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACnF,cAAc,QAAQ,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AAClF,eAAe,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;AACpF,eAAe,SAAS,EAAE,QAAQ,EAAE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE;;AAEpF;EACE;IACE,iCAAiC;IACjC,YAAY;EACd;EACA;IACE,uCAAuC;IACvC,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,uCAAuC,EAAE;AACjD;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ═══════════════════════════════════════════════════\n   InviteModal — Discord-quality invite acceptance UI\n   ═══════════════════════════════════════════════════ */\n\n.invite-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: overlayFadeIn 0.25s ease-out;\n}\n\n@keyframes overlayFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.invite-modal {\n  background-color: var(--bg-primary, #1e293b);\n  width: 440px;\n  max-width: 92vw;\n  border-radius: 12px;\n  box-shadow:\n    0 0 0 1px rgba(255,255,255,0.05),\n    0 16px 40px rgba(0,0,0,0.45),\n    0 0 80px -20px rgba(56, 189, 248, 0.15);\n  overflow: hidden;\n  position: relative;\n  animation: modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.92) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* ── Close button ── */\n.invite-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(0,0,0,0.3);\n  border: none;\n  color: rgba(255,255,255,0.7);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  transition: all 0.2s;\n  backdrop-filter: blur(4px);\n}\n\n.invite-close-btn:hover {\n  background: rgba(255,255,255,0.15);\n  color: white;\n  transform: rotate(90deg);\n}\n\n/* ── Banner ── */\n.invite-banner {\n  position: relative;\n  height: 100px;\n  background: linear-gradient(135deg, #0ea5e9 0%, #7c3aed 50%, #ec4899 100%);\n  overflow: hidden;\n}\n\n.invite-banner-gradient {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 40px;\n  background: linear-gradient(to top, var(--bg-primary, #1e293b), transparent);\n}\n\n/* ── Animated particles ── */\n.invite-banner-particles {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.particle {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  animation: particleFloat 6s ease-in-out infinite;\n}\n\n.particle-0 { left: 10%; top: 30%; animation-delay: 0s; width: 3px; height: 3px; }\n.particle-1 { left: 25%; top: 60%; animation-delay: 0.8s; width: 5px; height: 5px; }\n.particle-2 { left: 40%; top: 20%; animation-delay: 1.6s; width: 3px; height: 3px; }\n.particle-3 { left: 55%; top: 50%; animation-delay: 2.4s; width: 4px; height: 4px; }\n.particle-4 { left: 70%; top: 35%; animation-delay: 3.2s; width: 6px; height: 6px; }\n.particle-5 { left: 85%; top: 65%; animation-delay: 4s; width: 3px; height: 3px; }\n.particle-6 { left: 15%; top: 75%; animation-delay: 0.5s; width: 4px; height: 4px; }\n.particle-7 { left: 50%; top: 80%; animation-delay: 1.3s; width: 5px; height: 5px; }\n.particle-8 { left: 90%; top: 25%; animation-delay: 2.1s; width: 3px; height: 3px; }\n.particle-9 { left: 5%; top: 45%; animation-delay: 2.9s; width: 4px; height: 4px; }\n.particle-10 { left: 60%; top: 15%; animation-delay: 3.7s; width: 5px; height: 5px; }\n.particle-11 { left: 35%; top: 70%; animation-delay: 4.5s; width: 3px; height: 3px; }\n\n@keyframes particleFloat {\n  0%, 100% {\n    transform: translateY(0) scale(1);\n    opacity: 0.3;\n  }\n  50% {\n    transform: translateY(-20px) scale(1.5);\n    opacity: 0.8;\n  }\n}\n\n/* ── Server icon ── */\n.invite-server-icon-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: -36px;\n  position: relative;\n  z-index: 5;\n}\n\n.invite-server-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 20px;\n  background: var(--bg-secondary, #334155);\n  border: 5px solid var(--bg-primary, #1e293b);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n}\n\n.invite-server-icon-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.invite-server-icon-letter {\n  font-size: 28px;\n  font-weight: 700;\n  color: white;\n  background: linear-gradient(135deg, #0ea5e9, #7c3aed);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.invite-online-badge {\n  position: absolute;\n  bottom: 2px;\n  right: calc(50% - 40px);\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #22c55e;\n  border: 3px solid var(--bg-primary, #1e293b);\n  animation: badgePulse 2s ease-in-out infinite;\n}\n\n@keyframes badgePulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.4); }\n  50% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }\n}\n\n/* ── Content ── */\n.invite-content {\n  padding: 16px 28px 28px;\n  text-align: center;\n}\n\n.invite-subtitle {\n  color: var(--text-muted, #94a3b8);\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n.invite-server-name {\n  color: var(--text-normal, #f8fafc);\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 8px;\n  line-height: 1.3;\n}\n\n.invite-server-desc {\n  color: var(--text-muted, #94a3b8);\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0 0 16px;\n  max-height: 60px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Meta row ── */\n.invite-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.invite-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-muted, #94a3b8);\n  font-size: 13px;\n}\n\n.invite-meta-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.invite-meta-dot-online {\n  background-color: #22c55e;\n}\n\n/* ── Actions ── */\n.invite-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.invite-btn {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.invite-btn-secondary {\n  background: transparent;\n  color: var(--text-normal, #f8fafc);\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n.invite-btn-secondary:hover {\n  background: rgba(255,255,255,0.05);\n  border-color: rgba(255,255,255,0.2);\n}\n\n.invite-btn-primary {\n  background: linear-gradient(135deg, #0ea5e9, #7c3aed);\n  color: white;\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);\n}\n\n.invite-btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(14, 165, 233, 0.4);\n}\n\n.invite-btn-primary:active {\n  transform: translateY(0);\n}\n\n.invite-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ── Success state ── */\n.invite-success {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px;\n  background: rgba(34,197,94,0.1);\n  border: 1px solid rgba(34,197,94,0.2);\n  border-radius: 8px;\n  color: #22c55e;\n  font-weight: 500;\n  font-size: 14px;\n  animation: successPop 0.3s ease-out;\n}\n\n@keyframes successPop {\n  from { transform: scale(0.9); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n/* ── Error state ── */\n.invite-error-state {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-muted, #94a3b8);\n}\n\n.invite-error-state svg {\n  color: #ef4444;\n  margin-bottom: 4px;\n}\n\n.invite-error-state h3 {\n  color: var(--text-normal, #f8fafc);\n  font-size: 18px;\n  margin: 0;\n}\n\n.invite-error-state p {\n  font-size: 13px;\n  margin: 0 0 12px;\n}\n\n/* ── Loading skeletons ── */\n.invite-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 0;\n}\n\n.invite-skeleton {\n  background: linear-gradient(\n    90deg,\n    rgba(255,255,255,0.04) 25%,\n    rgba(255,255,255,0.08) 50%,\n    rgba(255,255,255,0.04) 75%\n  );\n  background-size: 200% 100%;\n  border-radius: 6px;\n  animation: skeletonShimmer 1.5s infinite;\n}\n\n.invite-skeleton-title {\n  width: 180px;\n  height: 24px;\n}\n\n.invite-skeleton-desc {\n  width: 260px;\n  height: 14px;\n}\n\n.invite-skeleton-meta {\n  width: 200px;\n  height: 14px;\n}\n\n@keyframes skeletonShimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Animate spin utility ── */\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
